<template lang="html">
  <div>
    <div v-if="isLoading" class="regiterationLayout text-xs-center">
      <v-progress-circular :size="70" :width="5" indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else class="regiterationLayout text-xs-center">
      <h1 style="font-weight: 900; font-size:2.3em">ลงทะเบียนเข้างาน</h1>
      <v-layout row wrap class="mt-4">
        <v-flex xs12 sm2>
          <h2 class="titleOfTextfield">ค้นหา</h2>
        </v-flex>
        <v-flex xs12 sm8>
          <!-- <v-text-field v-model="searchText" v-on:change="searchShareholder" solo label="ชื่อ / นามสกุล / บริษัท / เลขผู้ถือหุ้น"></v-text-field> -->
          <v-select ref="shareholder" :items="shareholder" v-model="selectedItem" item-value="shareholder.info" autocomplete label="" placeholder="ชื่อ / นามสกุล / บริษัท / เลขผู้ถือหุ้น" required></v-select>
        </v-flex>
      </v-layout>
      <div class="formInfo" v-if="showInfo" v-show="showInfo">
        <div class="infoDiv">
          <div v-if="isLoadingRegister" class="text-xs-center">
            <v-progress-circular :size="70" :width="5" indeterminate color="primary"></v-progress-circular>
          </div>
          <div v-if="!isLoadingRegister">
            <v-layout row wrap v-show="selectedItem.info.title != 'บริษัท' ">
              <v-flex xs12 sm2>
                <h3>ชื่อ-นามสกุล :</h3>
              </v-flex>
              <v-flex xs12 sm7>
                <h3>{{selectedItem.info.title}} {{selectedItem.info.firstname}} {{selectedItem.info.lastname}}</h3>
              </v-flex>
              <v-flex xs12 sm3 class="text-xs-right" v-if = "selectedItem.info.proxyname == null">
                <v-btn @click="printShareholderTemplate('/shareholdertemplate', selectedItem.info, selectedItem.info)" v-show="selectedItem.info.register != 0" style="width:100% height:60px;font-weight: bold;" color="primary darken-2" dark>พิมพ์บัตรลงคะแนน</v-btn>
              </v-flex>
              <v-flex xs12 sm3 class="text-xs-right" v-if = "selectedItem.info.proxyname != null">
                <v-btn @click="printProxyTemplate('/proxytemplate', selectedItem.info, selectedItem.info)" v-show="selectedItem.info.register != 0" style="width:100% height:60px;font-weight: bold;" color="primary darken-2" dark>พิมพ์บัตรลงคะแนน</v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-4" v-show="selectedItem.info.title == 'บริษัท' ">
              <v-flex xs12 sm2>
                <h3>ชื่อบริษัท :</h3>
              </v-flex>
              <v-flex xs12 sm7>
                <h3>{{selectedItem.info.companyname}} </h3>
              </v-flex>
              <v-flex xs12 sm3 class="text-xs-right" v-if = "selectedItem.info.proxyname == null">
                <v-btn @click="printShareholderTemplate('/shareholdertemplate', selectedItem.info, selectedItem.info)" v-show="selectedItem.info.register != 0" style="width:100% height:60px;font-weight: bold;" color="primary darken-2" dark>พิมพ์บัตรลงคะแนน</v-btn>
              </v-flex>
              <v-flex xs12 sm3 class="text-xs-right" v-if = "selectedItem.info.proxyname != null">
                <v-btn @click="printProxyTemplate('/proxytemplate', selectedItem.info, selectedItem.info)" v-show="selectedItem.info.register != 0" style="width:100% height:60px;font-weight: bold;" color="primary darken-2" dark>พิมพ์บัตรลงคะแนน</v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-4">
              <v-flex xs12 sm2>
                <h3>จำนวนหุ้น</h3>
              </v-flex>
              <v-flex xs12 sm2>
                <h3>{{selectedItem.info.q_share.toLocaleString()}}</h3>
              </v-flex>
              <v-flex xs12 sm1>
                <h3>หุ้น</h3>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-4" v-show="selectedItem.info.proxyname != null ">
              <v-flex xs12 sm4>
                <h3>ชื่อ-นามสกุลผู้มอบฉันทะ:</h3>
              </v-flex>
              <v-flex xs12 sm7>
                <h3>{{ selectedItem.info.proxytitle }} {{ selectedItem.info.proxyname }} {{ selectedItem.info.proxylastname}}</h3>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-4">
              <v-flex xs12 sm2>
                <h3>สถานะ :</h3>
              </v-flex>
              <v-flex xs12 sm4>
                <h3 v-show="selectedItem.info.register == 0">ยังไม่ได้ลงทะเบียน</h3>
                <h3 v-show="selectedItem.info.register != 0">ลงทะเบียนแล้ว</h3>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-4">
              <v-flex xs12 sm12  class="text-xs-right">
                <v-btn  v-show="selectedItem.info.register == 0" style="width:100% height:60px;font-weight: bold;" @click.stop="proxyDialog = true" large color="amber darken-2" dark depressed>ผู้รับมอบฉันทะ</v-btn>
                <v-btn  v-show="selectedItem.info.register != 0" style="width:100% height:60px;font-weight: bold;" @click.stop="proxyDialog = true" large disabled >ผู้รับมอบฉันทะ</v-btn>
                <!-- </v-flex>
                <v-flex xs12 sm3 class="text-xs-right"> -->
                <v-btn v-show="selectedItem.info.register == 0" @click.native.stop="registerDialog = true" style="width:100% height:60px;background-color:#61C356;" large dark depressed>ลงทะเบียน</v-btn>
                <v-btn v-show="selectedItem.info.register != 0" style="width:100% height:60px" large  disabled>ลงทะเบียน</v-btn>
              </v-flex>
            </v-layout>
          </div>

          <v-dialog v-model="proxyDialog" width="60%">
            <v-form ref="form">

              <v-card>
                <v-card-title>
                  <h2>ลงทะเบียนแบบมอบฉันทะ</h2>
                </v-card-title>
                <v-card-text >
                <v-layout row wrap  class="mt-4">
                  <v-flex xs12 sm2 class="pd5"  >
                    <v-select
                    ref="proxyTitle"
                    :items="title"
                    v-model="proxyTitle"
                    autocomplete
                    label=""
                    placeholder="คำนำหน้า"
                    :rules="[() => !!proxyTitle || 'This field is required']"
                    required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm5 class="pd5">
                    <v-text-field v-model="proxyName"  label="ชื่อ" ref="proxyName" :rules="[() => !!proxyName || 'This field is required']" required>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5 class="pd5">
                    <v-text-field v-model="proxyLastname" label="นามสกุล"
                    ref="proxyLastname"
                    :rules="[() => !!proxyLastname || 'This field is required']"
                    required ></v-text-field>
                  </v-flex >

                </v-layout>
                <v-layout row wrap class="mt-4">
                  <v-flex xs12 sm2 >
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-btn style="width:100% height:60px" @click="clearProxyDialog" @click.stop="proxyDialog=false" large >ย้อนกลับ</v-btn>

                  </v-flex >
                  <v-flex xs12 sm4>
                  </v-flex >
                  <v-flex xs12 sm2 style="text-align:right;" >
                    <v-btn style="width:100% height:60px" @click='register("proxy")' large color="success">ลงทะเบียน</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-form>
        </v-dialog>
        <v-layout row justify-center>
          <!-- <v-btn color="primary" dark >Open Dialog</v-btn> -->
          <v-dialog v-model="registerDialog"  max-width="400">
            <v-card>
              <v-card-title ></v-card-title>
              <v-card-text style="text-align:center;"><h2>ยืนยันการลงทะเบียนผู้ถือหุ้น</h2></v-card-text>
              <v-card-actions>
                <v-btn color="green darken-1" flat="flat" @click.native="registerDialog = false">ย้อนกลับ</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat="flat" @click="register('simple')" @click.native="registerDialog = false">ยืนยัน</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { Encode, Decode } from '@/services'
export default {
  data () {
    return {
      selectedItem: {},
      shareholder: [],
      agendaList: [],
      proxyDialog: false,
      registerDialog: false,
      title: [ 'นาย', 'นาง', 'นางสาว' ],
      proxyTitle: '',
      proxyName: '',
      proxyLastname: '',
      showInfo: false,
      errorMessages: [],
      checkProxyForm: false,
      isLoading: false,
      isLoadingRegister: false
    }
  },
  sockets: {
    getRegisterInfo: function (val) {
      this.shareholder[val.info.id - 1].info = Object.assign({}, val.info)
      if (this.selectedItem.info.id === val.info.id) {
        this.selectedItem = Object.assign({}, val)
      }
    }
  },
  created () {
    this.isLoading = true
  },
  computed: {
    termYear () {
      if (this.$cookies.isKey('shareholder_termyear')) {
        return JSON.parse(Decode.decode(this.$cookies.get('shareholder_termyear')))
      } else {
        return ''
      }
    },
    userInfo () {
      if (this.$cookies.isKey('shareholder_information')) {
        return JSON.parse(Decode.decode(this.$cookies.get('shareholder_information')))
      } else {
        return ''
      }
    }
  },
  methods: {
    getTermYear () {
      this.axios.post(process.env.API + '/getTermYearLatest').then((response) => {
        var information = { term: response.data.term, year: response.data.year, title: response.data.title, titleEN: response.data.titleEN }
        this.$cookies.set('shareholder_termyear', Encode.encode(information), null, '/', process.env.DOMAIN)
        this.queryAgenda()
      })
    },
    queryShareholder () {
      this.axios.get(process.env.API + '/getAllShareholder/' + this.termYear.term + '/' + this.termYear.year).then((response) => {
        var result = response.data
        if (response.status === 200) {
          this.isLoading = false
          this.shareholder = result
        }
      })
    },
    queryAgenda () {
      this.axios.get(process.env.API + '/getAgendaInYear/' + this.termYear.term + '/' + this.termYear.year).then((response) => {
        var result = response.data
        if (response.status === 200) {
          this.agendaList = result
          this.queryShareholder()
        }
      })
    },
    register (registerBy) {
      var data = {}
      this.isLoadingRegister = true
      if (registerBy === 'proxy') {
        if (this.proxyTitle === '' || this.proxyName === '' || this.proxyLastname === '' || this.proxyTitle === null || this.proxyName === null || this.proxyLastname === null) {
          this.checkProxyForm = true
          this.$swal('กรุณากรอกข้อมูลให้ครบค่ะ', '', 'error')
          this.isLoadingRegister = false
          return
        } else {
          data = {
            'registertype': registerBy,
            'proxytitle': this.proxyTitle,
            'proxyname': this.proxyName,
            'proxylastname': this.proxyLastname,
            'memberid': this.selectedItem.info.memberid,
            'registerby': this.userInfo.username }
        }
      } else {
        // const swalWithBootstrapButtons = this.$swal.mixin({
        //   confirmButtonClass: 'btn btn-success',
        //   cancelButtonClass: 'btn btn-danger',
        //   buttonsStyling: false
        // })
        //
        // swalWithBootstrapButtons({
        //   title: 'Are you sure?',
        //   text: "You won't be able to revert this!",
        //   type: 'warning',
        //   showCancelButton: true,
        //   confirmButtonText: 'Yes, delete it!',
        //   cancelButtonText: 'No, cancel!',
        //   reverseButtons: true
        // }).then((result) => {
        //   if (result.value) {
        //     swalWithBootstrapButtons(
        //       'Deleted!',
        //       'Your file has been deleted.',
        //       'success'
        //     )
        //   } else if (
        //     // Read more about handling dismissals
        //     result.dismiss === this.$swal.DismissReason.cancel
        //   ) {
        //     swalWithBootstrapButtons(
        //       'Cancelled',
        //       'Your imaginary file is safe :)',
        //       'error'
        //     )
        //   }
        // })
        data = {
          'registertype': registerBy,
          'memberid': this.selectedItem.info.memberid,
          'registerby': this.userInfo.username }
      }

      this.axios.post(process.env.API + '/register/' + this.termYear.term + '/' + this.termYear.year, data).then((response) => {
        var result = response.data
        if (response.status === 200) {
          if (result.status === 'success') {
            this.clearProxyDialog()
            this.proxyDialog = false
            // this.selectedItem = Object.assign({}, { info: result.info })
            // this.selectedItem.info.register = result.info
            // this.shareholder[result.info.id - 1].info = result.info
            // this.queryShareholder()
            this.$socket.emit('setPresentation')
            this.$socket.emit('registered', { info: result.info })
          }
        }
        this.isLoadingRegister = false
      })
    },
    clearProxyDialog () {
      // this.proxyTitle = ''
      // this.proxyName = ''
      // this.proxyLastname = ''
      // Object.keys(this.proxyTitle)[0].reset()
      // Object.keys(this.proxyName)[0].reset()
      // Object.keys(this.proxyLastname)[0].reset()
      this.$refs.form.reset()
    },
    printShareholderTemplate (url, itemMember, itemAgenda) {
      this.agendatest = itemAgenda.id
      this.nametest = itemMember.memberid

      if (url === '/shareholdertemplate') {
        var newWindow = window.open(url + '/' + this.nametest, '_blank', 'width=1280, height=720')
        setTimeout(function () { newWindow.print() }, 1500)
      } else {
        this.$router.push(url)
      }
    },
    printProxyTemplate (url, itemMember, itemAgenda) {
      this.agendatest = itemAgenda.id
      this.nametest = itemMember.memberid
      if (url === '/proxytemplate') {
        var newWindow = window.open(url + '/' + this.nametest, '_blank', 'width=1280, height=720')
        setTimeout(function () { newWindow.print() }, 1500)
      } else {
        this.$router.push(url)
      }
    }
  },
  mounted () {
    this.getTermYear()
  },
  watch: {
    selectedItem (item) {
      this.showInfo = true
    }
  }
}
</script>

<style lang="css" scoped>
.titleOfTextfield{
  padding: 18px 0 0 !important;
}
.regiterationLayout{
  /* border: solid;  */
  width : 70%;
  height: 70%;
  margin: 10% auto;
  /* text-align: center; */
}

.LoadingLayout{
  min-height: 60vh;
  margin: auto;
}

.searchShareholder{
  margin-top: 25px;
}

.formInfo{
  margin-top:10%;
  text-align: left;
}
.infoDiv{
  border: 2px solid #ccc;
  border-radius: 1em;
  padding: 2em;
}
.pd5{
  padding: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/contents/RegisterShareholder.vue